/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Footer_EditorInputs */

const en_gc_footer_editor = /** @type {(inputs: Gc_Footer_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online editor`)
};

const zh_gc_footer_editor = /** @type {(inputs: Gc_Footer_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线编辑器`)
};

/**
* | output |
* | --- |
* | "Online editor" |
*
* @param {Gc_Footer_EditorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_footer_editor = /** @type {((inputs?: Gc_Footer_EditorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Footer_EditorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_footer_editor(inputs)
	return zh_gc_footer_editor(inputs)
});
export { gc_footer_editor as "gc.footer.editor" }